/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {releaseEmailUpdate} from '../api'

export const useMutationReleaseEmailUpdate = createReactQueryMutationHook('releaseEmailUpdate', releaseEmailUpdate)
